export default "__VITE_ASSET__BQGFRrDW__"